import { defineComponent as _defineComponent } from 'vue'
import { Stars, Typo, Divider, Button, IconName } from '@travelata-libs/ui-kit';
import { parseISO, format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { computed, ref } from 'vue';
import { type HotelReview } from '../api/types';


interface HotelReviewCardProps {
    hotelReview: HotelReview;
    isDividerVisible?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HotelReviewCard',
  props: {
    hotelReview: null,
    isDividerVisible: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { hotelReview: HotelReview, isDividerVisible: boolean };



const MAX_HEIGHT_TEXT = 120;

const textRef = ref<HTMLElement | null>(null);

const shouldShowEllipsis = ref(true);

const rate = computed(() => Math.ceil(props.hotelReview.rate || 0));
const createdDate = computed(() => {
    if(!props.hotelReview.createdDate) return '';
    return format(parseISO(props.hotelReview.createdDate), 'dd.MM.yyyy');
});
const travelDate = computed(() => {
    if(!props.hotelReview.travelDate) return ''

    const parsedDate = parseISO(props.hotelReview.travelDate);

    return `Дата пребывания: ${format(parsedDate, 'LLLL yyyy', { locale: ru })} г.`;
});

const dates = computed(() => [createdDate.value, travelDate.value].filter((date) => !!date));

const buttonText = computed(() => shouldShowEllipsis.value ? 'Читать далее' : 'Свернуть'); 
const buttonIcon = computed(() => shouldShowEllipsis.value ? IconName.ChevronDown : IconName.ChevronUp);
const hasTextEllipsis = computed(() => textRef.value && MAX_HEIGHT_TEXT < textRef.value.offsetHeight);

return { __sfc: true,props, MAX_HEIGHT_TEXT, textRef, shouldShowEllipsis, rate, createdDate, travelDate, dates, buttonText, buttonIcon, hasTextEllipsis, Stars, Typo, Divider, Button }
}

})